import Lenis from 'lenis';

let lenis = null;

export function initLenis(reducedMotion) {
  if (lenis) return lenis;
  lenis = new Lenis({
    duration: 1.15,
    smoothWheel: !reducedMotion,
    touchMultiplier: 1.4
  });
  return lenis;
}

export function getLenis() {
  return lenis;
}

export function destroyLenis() {
  if (lenis) {
    lenis.destroy();
    lenis = null;
  }
}

export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) {
    lenis.scrollTo(el, { offset: -70, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}
